import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import CityPageSchema from "../components/SEO/CityPageSchema";

const faqs = [
  {
    q: "Does Almond Software work with clients in Nagpur remotely?",
    a: "Yes. We serve Nagpur businesses fully remotely — calls, design reviews and support are handled over video/phone, so you get the same process as a local Nagpur agency without the overhead."
  },
  {
    q: "What is the cost of a website in Nagpur?",
    a: "Business websites typically start around ₹25,000–₹45,000. Ecommerce and custom software projects are quoted after understanding your requirements — we share a fixed quote upfront, no surprises."
  },
  {
    q: "Can you build an ecommerce store for a Nagpur business?",
    a: "Yes, we build Shopify and custom ecommerce stores with payment gateway, inventory and shipping setup tailored for businesses selling to Nagpur and across Maharashtra."
  },
  {
    q: "Do you offer support after the website is live?",
    a: "Yes, we offer monthly maintenance plans covering updates, backups, security and content changes for all Nagpur clients."
  }
];

export default function NagpurLanding() {
  return (
    <>
      <Helmet>
        <title>Website Development Company in Nagpur | Almond Software</title>
        <meta
          name="description"
          content="Almond Software builds fast React websites, Shopify stores & custom software for businesses in Nagpur. Free quote, remote-friendly process, ongoing support."
        />
        <link
          rel="canonical"
          href="https://almondsoftwares.in/website-development-company-nagpur"
        />
        <meta
          property="og:title"
          content="Website Development Company in Nagpur | Almond Software"
        />
        <meta
          property="og:description"
          content="React, Shopify & custom software development for businesses in Nagpur, Maharashtra."
        />
        <meta
          property="og:image"
          content="https://almondsoftwares.in/logo192.png"
        />
        <meta
          property="og:url"
          content="https://almondsoftwares.in/website-development-company-nagpur"
        />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <CityPageSchema
        city="Nagpur"
        slug="website-development-company-nagpur"
        faqs={faqs}
      />

      <div className="bg-luxury" />

      {/* HERO */}
      <section className="hero">
        <div className="container hero-grid">
          <div className="hero-content">
            <h1>Website Development Company in Nagpur</h1>
            <p className="hero-glow">
              Almond Software helps businesses in Nagpur — clients worldwide. get modern, fast
              websites and ecommerce stores that are built to actually rank
              on Google, not just look good.
            </p>
            <div className="hero-buttons">
              <Link to="/contact" className="btn-primary">
                Get a Free Quote
              </Link>
              <Link to="/creations" className="btn-secondary">
                See Our Work
              </Link>
            </div>
            <div className="msme-badge">
              <span className="blue-tick">✓</span>
              Serving businesses across Nagpur &amp; Vidarbha
            </div>
          </div>

          <div className="hero-visual">
            <div className="floating-card">
              <h3>Why Nagpur businesses choose us</h3>
              <ul style={{ marginTop: 20, lineHeight: 2, color: "#475569" }}>
                <li>✅ Dedicated project manager for every client</li>
                <li>✅ SEO-first builds, not just design</li>
                <li>✅ React, Shopify &amp; Salesforce expertise</li>
                <li>✅ Transparent fixed pricing</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="section container">
        <h2 className="section-title">Our Services in Nagpur</h2>
        <div className="services">
          <div className="service-card">
            <i className="fa-solid fa-code" />
            <h3>Business Websites</h3>
            <p>
              Professional, mobile-first React websites for Nagpur-based
              retailers, clinics, consultants and service businesses.
            </p>
          </div>
          <div className="service-card">
            <i className="fa-solid fa-cart-shopping" />
            <h3>Ecommerce &amp; Shopify</h3>
            <p>
              Full ecommerce builds for Nagpur brands looking to sell online
              across Maharashtra — Shopify or custom cart, your choice.
            </p>
          </div>
          </div>
      </section>

      {/* PROCESS */}
      <section className="section container">
        <h2 className="section-title">How We Work</h2>
        <div className="process">
          <div>1. Free consultation call</div>
          <div>2. Design &amp; content plan</div>
          <div>3. Build &amp; review</div>
          <div>4. Launch &amp; SEO setup</div>
          <div>5. Ongoing support</div>
        </div>
      </section>

      {/* FAQ */}
      <section className="section container">
        <h2 className="section-title">Common Questions</h2>
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
          {faqs.map((f, i) => (
            <div
              key={i}
              className="service-card"
              style={{ marginBottom: 20, cursor: "default" }}
            >
              <h3 style={{ fontSize: 20 }}>{f.q}</h3>
              <p>{f.a}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="section container">
        <div className="more-projects">
          <h2>Ready to build your website in Nagpur?</h2>
          <p style={{ color: "#475569", marginTop: 12 }}>
            Talk to our team today — free quote, no obligation.
          </p>
          <div style={{ marginTop: 28 }}>
            <Link to="/contact" className="btn-primary">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}